import { API } from '../config';

export interface IAuth {
  email: string,
  password: string,
}

export const authLogin = async (auth: IAuth): Promise<string | undefined> => {

  const results = await fetch(`${API}/login`, {
    body: JSON.stringify(auth),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })
  if (results) {
    const value = await results.json();
    return value.token
  }

  return undefined;
}
